import React from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../actions/NotificationActions";
import Notification from "./Notification";

class NotificationContainer extends React.Component {
    
    render() {
        const { notifications, hideNotification, removeNotification } = this.props;
        return (
            <React.Fragment>
                {notifications.map(n => (<Notification key={n.id} data={n} hide={() => hideNotification(n.id)} remove={() => removeNotification(n.id)}/>))}
            </React.Fragment>
        );
    }
}

export default connect(
        s => s.notifications,
        d => bindActionCreators(actionCreators, d))
    (NotificationContainer);


// WEBPACK FOOTER //
// ./src/erp/components/NotificationContainer.js